/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'Constants'

const toMultipartFormData = (data = {}) => {
  const formData = new FormData()

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return
    }

    formData.append(key, value)
  })

  return formData
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getUserDetailsById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_USER_DETAILS_BY_ID}/${id}`, {
      // Laisse Combi (et tout autre appelant) gérer un 401/403 lui-même
      // au lieu de subir la déconnexion + redirection forcée de
      // l'intercepteur global (voir Services/Network) — même motif que
      // Services/Wallet.getClientWallets.
      suppressForbiddenRedirect: true,
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getUserStatisticsById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_USER_STATISTICS_BY_ID}/${id}`, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getUserDocumentTypes: () => {
    return axios.get(API_ENDPOINTS.GET_USER_DOCUMENTS_LOAD, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getDriverDocumentTypes: () => {
    return axios.get(API_ENDPOINTS.GET_DRIVER_DOCUMENTS_LOAD, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getCorporateDocumentTypes: () => {
    return axios.get(API_ENDPOINTS.GET_CORPORATE_DOCUMENTS_LOAD, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getUserDocumentsByUserId: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_USER_DOCUMENTS_BY_USER_ID}/${id}`, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  updateUserDocument: (image, user_id, document_type_id) => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('user_id', user_id);
    formData.append('document_type_id', document_type_id);
    return axios.put(API_ENDPOINTS.UPDATE_PROFILE_DOC_CORP, formData, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'multipart/form-data',
        'x-tenant-slug': 'default',
      },
    });
  },
  getDriverDocumentsByDriverId: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_DRIVER_DOCUMENTS_BY_DRIVER_ID}/${id}`, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getDriverContractDownload: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_DRIVER_CONTRACT_DOWNLOAD}/${id}/download`, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  getCorporateDocumentsByDriverId: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_CORPORATE_DOCUMENTS_BY_DRIVER_ID}/${id}?userType=CORPORATE`, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  requestOtp: (data) => {
    return axios.post(`${API_ENDPOINTS.DRIVER_ENDPOINT}/request-otp`, data, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  requestEmailOtp: (data) => {
    return axios.post(`${API_ENDPOINTS.DRIVER_ENDPOINT_V2}/sent-email-otp`, data, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  verifyEmailOtp: (data) => {
    return axios.post(`${API_ENDPOINTS.DRIVER_ENDPOINT_V2}/verify-email-otp`, data, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
        'x-tenant-slug': 'default',
      },
    })
  },
  updateUserProfileById: (id, data) => {
    const formData = data instanceof FormData ? data : toMultipartFormData(data)

    return axios.put(`${API_ENDPOINTS.UPDATE_CUSTOMER_DETAILS_BY_ID}/${id}`, formData, {
      headers: {
        isAuthRequired: true,
        'x-tenant-slug': 'default',
      },
    })
  },
  updateDriverProfileById: (id, data) => {
    const formData = data instanceof FormData ? data : toMultipartFormData(data)

    return axios.put(`${API_ENDPOINTS.UPDATE_DRIVER}/${id}`, formData, {
      headers: {
        isAuthRequired: true,
        'x-tenant-slug': 'default',
      },
    })
  },
  updateCorporateById: (id, data) => {
    const formData = data instanceof FormData ? data : toMultipartFormData(data)

    return axios.put(`${API_ENDPOINTS.UPDATE_CORPORATE_DETAILS_BY_ID}/${id}`, formData, {
      headers: {
        isAuthRequired: true,
        'x-tenant-slug': 'default',
      },
    })
  },
  updateCorporateProfileById: (id, data) => {
    const formData = data instanceof FormData ? data : toMultipartFormData(data)

    return axios.put(`${API_ENDPOINTS.UPDATE_PROFILE_DOC_CORP}`, formData, {
      headers: {
        isAuthRequired: true,
        'x-tenant-slug': 'default',
      },
    })
  },
  // Settings
  updateAppState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_APP_STATE, data, {
      headers: { isAuthRequired: true, 'Content-Type': 'application/json' },
    })
  },
  updateSmsState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SMS_STATE, data, {
      headers: { isAuthRequired: true, 'Content-Type': 'application/json' },
    })
  },
}
